var _defs, _path, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAvatar29(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_50_Kids_Icons-26",
    "data-name": "50_Kids_Icons-26",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1103",
    "data-name": "Path 1103",
    d: "M0,40A40,40,0,1,1,40,80,40,40,0,0,1,0,40Z"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_1094",
    "data-name": "Path 1094",
    d: "M0,40A40,40,0,1,1,40,80,40,40,0,0,1,0,40Z",
    fill: "#db4646"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4503",
    "data-name": "Group 4503"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4486",
    "data-name": "Group 4486",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4471",
    "data-name": "Group 4471",
    transform: "translate(11.222 22.263)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1095",
    "data-name": "Path 1095",
    d: "M75.9,320.538l3.168.285.517,12.02-7.766-2.408Z",
    transform: "translate(-71.823 -292.717)",
    fill: "#2b1d2b"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_4466",
    "data-name": "Group 4466",
    transform: "translate(2.909)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4458",
    "data-name": "Group 4458",
    transform: "translate(9.449)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_56",
    "data-name": "Ellipse 56",
    cx: 2.928,
    cy: 2.51,
    rx: 2.928,
    ry: 2.51,
    transform: "matrix(0.53, -0.848, 0.848, 0.53, 0, 4.968)",
    fill: "#2b1d2b"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_57",
    "data-name": "Ellipse 57",
    cx: 2.928,
    cy: 2.51,
    rx: 2.928,
    ry: 2.51,
    transform: "matrix(0.53, -0.848, 0.848, 0.53, 1.676, 7.549)",
    fill: "#2b1d2b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4459",
    "data-name": "Group 4459",
    transform: "translate(6.209 2.965)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_58",
    "data-name": "Ellipse 58",
    cx: 2.825,
    cy: 2.421,
    rx: 2.825,
    ry: 2.421,
    transform: "matrix(0.53, -0.848, 0.848, 0.53, 0, 4.792)",
    fill: "#2b1d2b"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_59",
    "data-name": "Ellipse 59",
    cx: 2.825,
    cy: 2.421,
    rx: 2.825,
    ry: 2.421,
    transform: "matrix(0.53, -0.848, 0.848, 0.53, 1.617, 7.282)",
    fill: "#2b1d2b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4460",
    "data-name": "Group 4460",
    transform: "translate(3.77 6.96)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_60",
    "data-name": "Ellipse 60",
    cx: 2.721,
    cy: 2.332,
    rx: 2.721,
    ry: 2.332,
    transform: "matrix(0.53, -0.848, 0.848, 0.53, 0, 4.616)",
    fill: "#2b1d2b"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_61",
    "data-name": "Ellipse 61",
    cx: 2.721,
    cy: 2.332,
    rx: 2.721,
    ry: 2.332,
    transform: "matrix(0.53, -0.848, 0.848, 0.53, 1.557, 7.014)",
    fill: "#2b1d2b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4461",
    "data-name": "Group 4461",
    transform: "translate(2.031 11.453)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_62",
    "data-name": "Ellipse 62",
    cx: 2.617,
    cy: 2.243,
    rx: 2.617,
    ry: 2.243,
    transform: "matrix(0.53, -0.848, 0.848, 0.53, 0, 4.44)",
    fill: "#2b1d2b"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_63",
    "data-name": "Ellipse 63",
    cx: 2.617,
    cy: 2.243,
    rx: 2.617,
    ry: 2.243,
    transform: "matrix(0.53, -0.848, 0.848, 0.53, 1.498, 6.746)",
    fill: "#2b1d2b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4462",
    "data-name": "Group 4462",
    transform: "translate(0.891 15.913)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_64",
    "data-name": "Ellipse 64",
    cx: 2.513,
    cy: 2.154,
    rx: 2.513,
    ry: 2.154,
    transform: "matrix(0.53, -0.848, 0.848, 0.53, 0, 4.264)",
    fill: "#2b1d2b"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_65",
    "data-name": "Ellipse 65",
    cx: 2.513,
    cy: 2.154,
    rx: 2.513,
    ry: 2.154,
    transform: "matrix(0.53, -0.848, 0.848, 0.53, 1.438, 6.479)",
    fill: "#2b1d2b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4463",
    "data-name": "Group 4463",
    transform: "translate(0.247 19.809)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_66",
    "data-name": "Ellipse 66",
    cx: 2.41,
    cy: 2.065,
    rx: 2.41,
    ry: 2.065,
    transform: "matrix(0.53, -0.848, 0.848, 0.53, 0, 4.088)",
    fill: "#2b1d2b"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_67",
    "data-name": "Ellipse 67",
    cx: 2.41,
    cy: 2.065,
    rx: 2.41,
    ry: 2.065,
    transform: "matrix(0.53, -0.848, 0.848, 0.53, 1.379, 6.211)",
    fill: "#2b1d2b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4464",
    "data-name": "Group 4464",
    transform: "translate(0 22.609)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_68",
    "data-name": "Ellipse 68",
    cx: 2.306,
    cy: 1.976,
    rx: 2.306,
    ry: 1.976,
    transform: "matrix(0.53, -0.848, 0.848, 0.53, 0, 3.911)",
    fill: "#2b1d2b"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_69",
    "data-name": "Ellipse 69",
    cx: 2.306,
    cy: 1.976,
    rx: 2.306,
    ry: 1.976,
    transform: "matrix(0.53, -0.848, 0.848, 0.53, 1.32, 5.943)",
    fill: "#2b1d2b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4465",
    "data-name": "Group 4465",
    transform: "translate(0.047 23.781)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_70",
    "data-name": "Ellipse 70",
    cx: 2.202,
    cy: 1.887,
    rx: 2.202,
    ry: 1.887,
    transform: "matrix(0.53, -0.848, 0.848, 0.53, 0, 3.735)",
    fill: "#2b1d2b"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_71",
    "data-name": "Ellipse 71",
    cx: 2.202,
    cy: 1.887,
    rx: 2.202,
    ry: 1.887,
    transform: "matrix(0.53, -0.848, 0.848, 0.53, 1.26, 5.676)",
    fill: "#2b1d2b"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4470",
    "data-name": "Group 4470",
    transform: "translate(1.017 25.08)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4469",
    "data-name": "Group 4469"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4467",
    "data-name": "Group 4467"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1096",
    "data-name": "Path 1096",
    d: "M81.8,303.808c-.907-1.107-1.965-1.081-2.352.059l-1.024,3.013c-.387,1.139.436,1.805,1.829,1.479l1.893-.443a1.494,1.494,0,0,0,.885-2.6Z",
    transform: "translate(-78.333 -302.995)",
    fill: "#fceeb3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4468",
    "data-name": "Group 4468",
    transform: "translate(5.254 2.445)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1097",
    "data-name": "Path 1097",
    d: "M115.224,318.727c1.393-.326,2.217.34,1.829,1.479l-1.024,3.013c-.387,1.139-1.446,1.166-2.352.059l-1.232-1.5a1.494,1.494,0,0,1,.885-2.6Z",
    transform: "translate(-111.96 -318.645)",
    fill: "#fceeb3"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_1098",
    "data-name": "Path 1098",
    d: "M105.107,320.673a1.492,1.492,0,1,1-.933-1.893A1.492,1.492,0,0,1,105.107,320.673Z",
    transform: "translate(-98.472 -316.247)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4485",
    "data-name": "Group 4485",
    transform: "translate(49.424 21.736)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1099",
    "data-name": "Path 1099",
    d: "M388,322.963h-3.18l-1.59,11.926,7.951-1.7Z",
    transform: "translate(-372.77 -294.236)",
    fill: "#2b1d2b"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_4480",
    "data-name": "Group 4480"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4472",
    "data-name": "Group 4472"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_72",
    "data-name": "Ellipse 72",
    cx: 2.51,
    cy: 2.928,
    rx: 2.51,
    ry: 2.928,
    transform: "matrix(0.892, -0.452, 0.452, 0.892, 1.9, 2.268)",
    fill: "#2b1d2b"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_73",
    "data-name": "Ellipse 73",
    cx: 2.51,
    cy: 2.928,
    rx: 2.51,
    ry: 2.928,
    transform: "matrix(0.892, -0.452, 0.452, 0.892, 0, 4.689)",
    fill: "#2b1d2b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4473",
    "data-name": "Group 4473",
    transform: "translate(3.298 3.252)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_74",
    "data-name": "Ellipse 74",
    cx: 2.421,
    cy: 2.825,
    rx: 2.421,
    ry: 2.825,
    transform: "matrix(0.892, -0.452, 0.452, 0.892, 1.833, 2.188)",
    fill: "#2b1d2b"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_75",
    "data-name": "Ellipse 75",
    cx: 2.421,
    cy: 2.825,
    rx: 2.421,
    ry: 2.825,
    transform: "matrix(0.892, -0.452, 0.452, 0.892, 0, 4.523)",
    fill: "#2b1d2b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4474",
    "data-name": "Group 4474",
    transform: "translate(5.705 7.459)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_76",
    "data-name": "Ellipse 76",
    cx: 2.332,
    cy: 2.721,
    rx: 2.332,
    ry: 2.721,
    transform: "matrix(0.892, -0.452, 0.452, 0.892, 1.765, 2.107)",
    fill: "#2b1d2b"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_77",
    "data-name": "Ellipse 77",
    cx: 2.332,
    cy: 2.721,
    rx: 2.332,
    ry: 2.721,
    transform: "matrix(0.892, -0.452, 0.452, 0.892, 0, 4.357)",
    fill: "#2b1d2b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4475",
    "data-name": "Group 4475",
    transform: "translate(7.371 12.1)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_78",
    "data-name": "Ellipse 78",
    cx: 2.243,
    cy: 2.617,
    rx: 2.243,
    ry: 2.617,
    transform: "matrix(0.892, -0.452, 0.452, 0.892, 1.698, 2.027)",
    fill: "#2b1d2b"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_79",
    "data-name": "Ellipse 79",
    cx: 2.243,
    cy: 2.617,
    rx: 2.243,
    ry: 2.617,
    transform: "matrix(0.892, -0.452, 0.452, 0.892, 0, 4.191)",
    fill: "#2b1d2b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4476",
    "data-name": "Group 4476",
    transform: "translate(8.444 16.654)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_80",
    "data-name": "Ellipse 80",
    cx: 2.154,
    cy: 2.513,
    rx: 2.154,
    ry: 2.513,
    transform: "matrix(0.892, -0.452, 0.452, 0.892, 1.631, 1.947)",
    fill: "#2b1d2b"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_81",
    "data-name": "Ellipse 81",
    cx: 2.154,
    cy: 2.513,
    rx: 2.154,
    ry: 2.513,
    transform: "matrix(0.892, -0.452, 0.452, 0.892, 0, 4.024)",
    fill: "#2b1d2b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4477",
    "data-name": "Group 4477",
    transform: "translate(9.072 20.602)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_82",
    "data-name": "Ellipse 82",
    cx: 2.065,
    cy: 2.41,
    rx: 2.065,
    ry: 2.41,
    transform: "matrix(0.892, -0.452, 0.452, 0.892, 1.563, 1.866)",
    fill: "#2b1d2b"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_83",
    "data-name": "Ellipse 83",
    cx: 2.065,
    cy: 2.41,
    rx: 2.065,
    ry: 2.41,
    transform: "matrix(0.892, -0.452, 0.452, 0.892, 0, 3.858)",
    fill: "#2b1d2b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4478",
    "data-name": "Group 4478",
    transform: "translate(9.404 23.422)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_84",
    "data-name": "Ellipse 84",
    cx: 1.976,
    cy: 2.306,
    rx: 1.976,
    ry: 2.306,
    transform: "matrix(0.892, -0.452, 0.452, 0.892, 1.496, 1.786)",
    fill: "#2b1d2b"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_85",
    "data-name": "Ellipse 85",
    cx: 1.976,
    cy: 2.306,
    rx: 1.976,
    ry: 2.306,
    transform: "matrix(0.892, -0.452, 0.452, 0.892, 0, 3.692)",
    fill: "#2b1d2b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4479",
    "data-name": "Group 4479",
    transform: "translate(9.589 24.595)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_86",
    "data-name": "Ellipse 86",
    cx: 1.887,
    cy: 2.202,
    rx: 1.887,
    ry: 2.202,
    transform: "matrix(0.892, -0.452, 0.452, 0.892, 1.429, 1.705)",
    fill: "#2b1d2b"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_87",
    "data-name": "Ellipse 87",
    cx: 1.887,
    cy: 2.202,
    rx: 1.887,
    ry: 2.202,
    transform: "matrix(0.892, -0.452, 0.452, 0.892, 0, 3.526)",
    fill: "#2b1d2b"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4484",
    "data-name": "Group 4484",
    transform: "translate(7.805 26.077)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4483",
    "data-name": "Group 4483"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4481",
    "data-name": "Group 4481",
    transform: "translate(5.231)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1100",
    "data-name": "Path 1100",
    d: "M401.7,306.7c1-1.022,2.054-.9,2.337.269l.75,3.093c.284,1.17-.6,1.759-1.954,1.31l-1.846-.61a1.494,1.494,0,0,1-.648-2.674Z",
    transform: "translate(-399.743 -306.001)",
    fill: "#fceeb3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4482",
    "data-name": "Group 4482",
    transform: "translate(0 1.799)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1101",
    "data-name": "Path 1101",
    d: "M368.272,317.669c-1.358-.449-2.238.14-1.954,1.31l.75,3.093c.284,1.17,1.335,1.29,2.337.269l1.361-1.388a1.494,1.494,0,0,0-.649-2.674Z",
    transform: "translate(-366.264 -317.518)",
    fill: "#fceeb3"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_1102",
    "data-name": "Path 1102",
    d: "M389.808,321.7a1.492,1.492,0,1,0,1.1-1.8A1.492,1.492,0,0,0,389.808,321.7Z",
    transform: "translate(-386.094 -317.695)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4487",
    "data-name": "Group 4487",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1104",
    "data-name": "Path 1104",
    d: "M160.731,246.493c1.025,2.428.467,4.787-1.247,5.27s-3.933-1.093-4.958-3.521-.467-4.787,1.247-5.27S159.706,244.065,160.731,246.493Z",
    transform: "translate(-129.948 -204.934)",
    fill: "#e38a5b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1105",
    "data-name": "Path 1105",
    d: "M327.785,246.492c-1.025,2.428-.467,4.787,1.247,5.27s3.933-1.093,4.958-3.521.467-4.787-1.247-5.27S328.81,244.065,327.785,246.492Z",
    transform: "translate(-276.135 -204.934)",
    fill: "#e38a5b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4488",
    "data-name": "Group 4488",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1107",
    "data-name": "Path 1107",
    d: "M136.183,412.258l-.008-.132c0-8-2.995-15.753-6.652-17.229l-15.575-6.275a20.633,20.633,0,0,0-13.3-.017l-15.8,6.312c-3.66,1.465-6.655,9.208-6.655,17.209l-.008.132Z",
    transform: "translate(-65.966 -326.964)",
    fill: "#e38a5b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4489",
    "data-name": "Group 4489",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1109",
    "data-name": "Path 1109",
    d: "M234.763,277.007a6.219,6.219,0,0,1-6.219,6.219h-.754a6.219,6.219,0,0,1-6.219-6.219V260.989a6.219,6.219,0,0,1,6.219-6.219h.754a6.219,6.219,0,0,1,6.219,6.219Z",
    transform: "translate(-186.951 -214.962)",
    fill: "#e38a5b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4491",
    "data-name": "Group 4491",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4490",
    "data-name": "Group 4490",
    transform: "translate(27.833 18.107)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1111",
    "data-name": "Path 1111",
    d: "M204.9,143.36a10.422,10.422,0,0,1-10.423,10.422h-5.923A10.422,10.422,0,0,1,178.13,143.36V126.306a10.422,10.422,0,0,1,10.422-10.422h5.923A10.422,10.422,0,0,1,204.9,126.306Z",
    transform: "translate(-178.13 -115.884)",
    fill: "#f5b68c"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4492",
    "data-name": "Group 4492",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_88",
    "data-name": "Ellipse 88",
    cx: 1.548,
    cy: 1.548,
    r: 1.548,
    transform: "translate(34.537 40.012)",
    fill: "#318251"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_89",
    "data-name": "Ellipse 89",
    cx: 1.548,
    cy: 1.548,
    r: 1.548,
    transform: "translate(44.8 40.012)",
    fill: "#318251"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4493",
    "data-name": "Group 4493",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1114",
    "data-name": "Path 1114",
    d: "M178.945,102.076c-8.677,0-15.711,7.624-15.711,17.029a18.05,18.05,0,0,0,2.13,8.566l1.561-13.238h24.037l1.564,13.239a18.051,18.051,0,0,0,2.13-8.566C194.656,109.7,187.622,102.076,178.945,102.076Z",
    transform: "translate(-137.729 -86.127)",
    fill: "#2b1d2b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4494",
    "data-name": "Group 4494",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1116",
    "data-name": "Path 1116",
    d: "M252.214,279.542a2.384,2.384,0,0,1-4.653.538,2.526,2.526,0,0,0-.114.71,2.553,2.553,0,1,0,5.105,0A2.516,2.516,0,0,0,252.214,279.542Z",
    transform: "translate(-208.783 -235.864)",
    fill: "#e38a5b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4495",
    "data-name": "Group 4495",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1118",
    "data-name": "Path 1118",
    d: "M136.174,425.067c0-8-3-15.753-6.652-17.229l-12.384-4.989a10.937,10.937,0,0,1-19.889.053l-12.4,4.956c-3.66,1.465-6.655,9.208-6.655,17.209l-.008.132h58Z",
    transform: "translate(-65.966 -339.904)",
    fill: "#fcf2c8"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4496",
    "data-name": "Group 4496",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1120",
    "data-name": "Path 1120",
    d: "M186.765,120.554l-1.17-3.975L169.1,128.586v8.136l10.3-2.551C185.257,132.721,188.552,126.625,186.765,120.554Z",
    transform: "translate(-142.681 -98.364)",
    fill: "#2b1d2b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1121",
    "data-name": "Path 1121",
    d: "M293.191,157.8a32.017,32.017,0,0,0-2.7-11.509,7.032,7.032,0,1,0,2.7,11.509Z",
    transform: "translate(-237.181 -123.09)",
    fill: "#2b1d2b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4498",
    "data-name": "Group 4498",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4497",
    "data-name": "Group 4497",
    transform: "translate(35.843 48.578)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1123",
    "data-name": "Path 1123",
    d: "M229.4,310.9c0,.029,0,.062,0,.092a5.373,5.373,0,1,0,10.746,0c0-.031,0-.064,0-.092Z",
    transform: "translate(-229.398 -310.902)",
    fill: "#a91935"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1124",
    "data-name": "Path 1124",
    d: "M240.326,310.9v.46a1.687,1.687,0,0,0,1.687,1.688h5.528a1.688,1.688,0,0,0,1.689-1.688v-.46Z",
    transform: "translate(-238.618 -310.902)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4499",
    "data-name": "Group 4499",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_90",
    "data-name": "Ellipse 90",
    cx: 3.125,
    cy: 2.344,
    rx: 3.125,
    ry: 2.344,
    transform: "translate(46.685 43.107)",
    fill: "#eb987f"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_91",
    "data-name": "Ellipse 91",
    cx: 3.125,
    cy: 2.344,
    rx: 3.125,
    ry: 2.344,
    transform: "translate(29.497 43.107)",
    fill: "#eb987f"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4502",
    "data-name": "Group 4502",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4500",
    "data-name": "Group 4500",
    transform: "translate(33.125 37.686)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1127",
    "data-name": "Path 1127",
    d: "M213.188,243.3a2.882,2.882,0,0,1,2.748-.626.686.686,0,0,0,.365-1.322,4.3,4.3,0,0,0-4.082.978c-.656.6.317,1.563.97.97Z",
    transform: "translate(-212 -241.192)",
    fill: "#704d70"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4501",
    "data-name": "Group 4501",
    transform: "translate(44.864 37.686)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1128",
    "data-name": "Path 1128",
    d: "M291.7,242.333a4.3,4.3,0,0,0-4.082-.978.686.686,0,0,0,.365,1.322,2.882,2.882,0,0,1,2.748.626c.653.593,1.626-.374.97-.97Z",
    transform: "translate(-287.131 -241.192)",
    fill: "#704d70"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatar29);
export default __webpack_public_path__ + "static/media/avatar29.121bc2444973ed6fe336e8d535cff5da.svg";
export { ForwardRef as ReactComponent };